import styled, {css} from 'styled-components'

export const StyledPageHeaderContainer = styled.div`
    ${({theme: {palette, spacing}}) => css`
        display: grid;
        align-items: center;
        grid-template-columns: 1fr auto;
        border-bottom: 1px solid ${palette.neutral['200']};
        padding: ${spacing * 10}px ${spacing * 4}px ${spacing * 8}px;
    `}
`

export const StyledPageHeaderText = styled.div`
    ${({theme: {spacing, palette, typography}}) => css`
        & h1 {
            color: ${palette.neutral['900']};
            ${typography.displaySm};
            font-weight: 600;
            margin-bottom: ${spacing}px;
        }
        & p {
            color: ${palette.neutral['600']};
            ${typography.textMd}
        }
    `}
`
